export default {
  IRK_REGION_PRIVILEGE_UUID: '7030f3e5-4d75-a8e6-0bea-ca450836c616',
  RUSSIA_PRIVILEGE_UUID: 'adb07e64-b8fc-3cae-1b52-41471ace7c34',
  NO_BENEFITS_PRIVILEGE: '053a8b7c-7035-0617-6f74-1635ef3ba35b',
};
